import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import {SectionProps} from '../../utils/SectionProps';
import '../../assets/customStyles/styles.css';

const VIDEO_SRC   = process.env.PUBLIC_URL + '/video/hero.mp4';
const POSTER_SRC  = process.env.PUBLIC_URL + '/video/hero-poster.jpg';

const propTypes = {
    ...SectionProps.types
};

const defaultProps = {
    ...SectionProps.defaults
};

const videoStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'opacity 2.5s ease',
};

const Hero = ({
                  className,
                  topOuterDivider,
                  bottomOuterDivider,
                  topDivider,
                  bottomDivider,
                  hasBgColor,
                  invertColor,
                  ...props
              }) => {

    const outerClasses = classNames(
        'hero section center-content',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const videoA = useRef(null);
    const videoB = useRef(null);
    const activeRef = useRef(0); // 0 = A is main
    const crossfadingRef = useRef(false);

    useEffect(() => {
        const videos = [videoA.current, videoB.current];
        videos[1].style.opacity = '0';

        // Standby video stays preload="none" until the active one is loaded —
        // saves ~half the network at first paint without breaking the crossfade loop.
        const armStandby = () => {
            if (videos[1].getAttribute('src')) return;
            videos[1].setAttribute('preload', 'auto');
            videos[1].src = VIDEO_SRC;
            videos[1].load();
        };
        videos[0].addEventListener('loadeddata', armStandby, { once: true });

        const onTimeUpdate = () => {
            const idx = activeRef.current;
            const main = videos[idx];
            if (crossfadingRef.current || !main.duration) return;
            if (main.currentTime > main.duration - 1.5) {
                crossfadingRef.current = true;
                const next = videos[1 - idx];
                next.currentTime = 0;
                next.play();
                main.style.opacity = '0';
                next.style.opacity = '1';
                setTimeout(() => {
                    main.pause();
                    main.currentTime = 0;
                    activeRef.current = 1 - idx;
                    crossfadingRef.current = false;
                }, 2600);
            }
        };

        videos[0].addEventListener('timeupdate', onTimeUpdate);
        videos[1].addEventListener('timeupdate', onTimeUpdate);
        return () => {
            videos[0].removeEventListener('timeupdate', onTimeUpdate);
            videos[1].removeEventListener('timeupdate', onTimeUpdate);
            videos[0].removeEventListener('loadeddata', armStandby);
        };
    }, []);

    return (
        <section {...props} className={outerClasses}>
            <div className="edina_tm_universal_box_wrap">
                <div className="bg_wrap">
                    <div className="overlay_video">
                        <video
                            ref={videoA}
                            src={VIDEO_SRC}
                            poster={POSTER_SRC}
                            autoPlay
                            muted
                            playsInline
                            preload="metadata"
                            style={videoStyle}
                        />
                        <video
                            ref={videoB}
                            poster={POSTER_SRC}
                            muted
                            playsInline
                            preload="none"
                            style={videoStyle}
                        />
                    </div>
                </div>
                <div className="content hero">
                    <div className="container hero"/>
                </div>
            </div>
        </section>
    );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
